module.exports = __webpack_public_path__ + "static/bp2-d0642617dfac9318fe79985c46906506.jpg";